/* eslint-disable no-restricted-globals */
export const Types = {
  SET_HOTEL_DETAILS_INFO: 'hotelDetails/SET_HOTEL_DETAILS_INFO',
  SET_HOTEL_ROOMS_INFO: 'hotelDetails/SET_HOTEL_ROOMS_INFO',
  SET_ROOMS_AMOUNT: 'hotelDetails/SET_ROOMS_AMOUNT',
  SET_INITIAL_ROOMS_AMOUNT: 'hotelDetails/SET_INITIAL_ROOMS_AMOUNT',
  SET_HAS_CHECK_RATE_ERROR: 'hotelDetails/SET_HAS_CHECK_RATE_ERROR',
};

export interface IPhotos {
  title: string;
  url: string;
}

interface IPointsInterest {
  name: string;
  distance: string;
  category: string;
}

type SmilesAndMoneyOffers = {
  priceInMiles: number;
  priceInMoney: number;
};

export interface IRooms {
  id: string;
  key: string;
  roomType: string;
  description?: string;
  name: string;
  conveniences?: { id: string; label: string; icon: string }[];
  refundable: boolean;
  boardType: string;
  capacity: number;
  cancellationPolicies: {
    penaltie: {
      from: string;
      description: string;
    };
  };
  pricing: {
    dailyMiles: number;
    dailyMilesClub: number;
    dailyMoney: number;
    dailyWithServiceCharge: number;
    moneyWithServiceCharge: number;
    miles: number;
    milesClub: number;
    money: number;
    earnMiles: number;
    earnMilesClub: number;
    rates: number;
    smilesAndMoneyOffers: {
      offer1: SmilesAndMoneyOffers;
      offer2: SmilesAndMoneyOffers;
      offer3: SmilesAndMoneyOffers;
    };
  };
  available: boolean;
  traveler: {
    age: number;
    roomNumber: number;
    type: string;
  }[];
  photos?: {
    large: string
    medium: string
    small: string
  }[]
}

export interface IGeneralInfo {
  checkin: { time: string; extraInfo?: string };
  checkout: { time: string; extraInfo?: string };
  minAge?: string;
  cancellationPolicy?: string;
  hostingRules?: string;
  childrenPolicy?: string;
  pets?: string;
  paymentMethods?: string;
  other?: string;
}

interface IRecommendation {
  name: string;
  rating: number;
  city: string;
  photo: string;
  tags: never[];
  pricing: {
    miles: number;
    money: {
      value: number;
      currency: string;
    };
  };
}

export interface IHotel {
  id: string;
  cacheId: string;
  name: string;
  photos: IPhotos[];
  rating: number;
  city: string;
  address: string;
  latitude: string;
  longitude: string;
  conveniences: IConveniences[];
  description: string;
  pointsInterest: IPointsInterest[];
  rooms: IRooms[];
  generalInfo: IGeneralInfo;
  recommendation: IRecommendation[];
}

export interface IConveniences {
  id: string | number;
  label: string;
  name: string;
  icon: string;
  position?: number;
}

export interface IRoomsAmount {
  id: number | string;
  quantity: number;
}

export interface IDetailsReduxState {
  hotel: IHotel;
  roomsAmount: IRoomsAmount[];
  hasCheckRateError: boolean;
}

const initialState = {
  hotel: {
    id: '0',
    cacheId: '',
    name: '',
    photos: [],
    rating: 0,
    city: '',
    address: '',
    latitude: '',
    longitude: '',
    conveniences: [],
    description: '',
    pointsInterest: [],
    rooms: [],
    generalInfo: {
      checkin: { time: '' },
      checkout: { time: '' },
      cancellationPolicy: '',
      hostingRules: '',
      childrenPolicy: '',
      pets: '',
      paymentMethods: '',
      other: '',
    },
    recommendation: [],
  },
  roomsAmount: [],
  hasCheckRateError: false,
} as IDetailsReduxState;

export default function reducer(state = initialState, action: any = {}): IDetailsReduxState {
  switch (action.type) {
    case Types.SET_INITIAL_ROOMS_AMOUNT:
      return { ...state, roomsAmount: action.payload };
    case Types.SET_HOTEL_DETAILS_INFO:
      return { ...state, hotel: { ...state.hotel, ...action.payload } };
    case Types.SET_HOTEL_ROOMS_INFO:
      return { ...state, hotel: { ...state.hotel, rooms: action.payload } };
    case Types.SET_ROOMS_AMOUNT:
      return {
        ...state,
        roomsAmount: state.roomsAmount.map((roomsAmount: IRoomsAmount, index: number) =>
          action.payload.id === index ? { ...roomsAmount, quantity: action.payload.roomsAmount } : roomsAmount,
        ),
      };
    case Types.SET_HAS_CHECK_RATE_ERROR:
      return { ...state, hasCheckRateError: action.payload };
    default:
      return state;
  }
}

const setInitialRoomsAmount = (roomsAmount: IRoomsAmount[]) => ({
  type: Types.SET_INITIAL_ROOMS_AMOUNT,
  payload: roomsAmount,
});

const setHotelDetailsInfo = (hotelDetails: IHotel) => ({
  type: Types.SET_HOTEL_DETAILS_INFO,
  payload: hotelDetails,
});

const setHotelRoomsInfo = (rooms: IRooms[]) => ({
  type: Types.SET_HOTEL_ROOMS_INFO,
  payload: rooms,
});

const setRoomsAmount = (roomsAmount: number, id: number) => ({
  type: Types.SET_ROOMS_AMOUNT,
  payload: { roomsAmount, id },
});

const setHasCheckRateError = (status: boolean) => ({
  type: Types.SET_HAS_CHECK_RATE_ERROR,
  payload: status,
});

export const hotelDetailsActions = {
  setInitialRoomsAmount,
  setHotelDetailsInfo,
  setHotelRoomsInfo,
  setRoomsAmount,
  setHasCheckRateError,
};
